<template>
    <main id="modal-qr--wrapper">
        <div id="modal-qr-page">
            <div class="modal fade" id="modalVirtualCard" tabindex="-1" role="dialog" aria-labelledby="modalVirtualCardLabel" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body text-center px-5 mb-5">
                            <div class="row">
                                <div class="col">
                                    <img :src="cdn_url+'/assets/community/images/card.png'" alt="card-img" id="card-img">
                                </div>
                            </div>
                            <div class="row pt-4">
                                <div class="col">
                                    <span id="card-label">Nomor Kartu</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <span id="card-id">{{ user.hcid }}</span>
                                </div>
                            </div>
                            <div class="row pt-4">
                                <div class="col">
                                    <qrcode-vue :value="user.hcid" :size="size" :level="level" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
import { isMobile } from "mobile-device-detect";
import QrcodeVue from 'qrcode.vue';

export default {
    components: {
        QrcodeVue
    },
    props: [
        'cardNumber',
        'size',
        'level',
    ],
    data() {
        return {
            cdn_url:cdn_url,
            base_url:'',
            app_url:'',
            api_url:'',
            mobile: false,
            user:[],
        };
    },
    created() {
        this.base_url = base_url;
        this.app_url = app_url;
        this.api_url = api_url;
        this.mobile = isMobile;
        if(localStorage.getItem('user') != null){
            this.user = JSON.parse(localStorage.getItem('user'));
        }
    },
    methods: {}
};
</script>

<style scoped lang="scss">
#modal-qr-page{
    .modal-content{
        background: #FFFFFF;
        border-radius: 10px;
    }
    .modal-header{
        border-bottom:unset;
    }
    .modal-title{
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 30px;
        color: #E61B33;
    }
    #card-img{
        max-height: 124px;
    }
    #card-id{
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 25px;
        text-align: center;
        color: #282828;
    }
    #card-label{
        font-style: normal;
        font-weight: 300;
        font-size: 14px;
        line-height: 22px;
        text-align: center;
        color: #B4B4B4;
    }
}
</style>
